export default "__VITE_ASSET__8a51cda1__"